import { lazy, Suspense } from 'react';
import { Layout } from '@/app/Layout';
import { footerHighlightTargets, links, primaryNavTargets } from './config';
import { AppHead } from './AppHead';
import { LandingLazyLoad } from './ui';
import { Footer } from '@/widgets/footer';
import { Hero } from '@/widgets/hero';
import { NavBarV2 } from '@/widgets/navbar';

const WhyBanner3 = lazy(() => import('@/widgets/landing-content/WhyBanners').then((module) => ({ default: module.WhyBanner3 })));
const WhyBanner2 = lazy(() => import('@/widgets/landing-content/WhyBanners').then((module) => ({ default: module.WhyBanner2 })));
const VideoBannerTop = lazy(() =>
  import('@/widgets/landing-content/VideoBannerTop').then((module) => ({ default: module.VideoBannerTop })),
);
const ExampleProjects = lazy(() =>
  import('@/widgets/landing-content/ExampleProjects').then((module) => ({ default: module.ExampleProjects })),
);

export function LandingPage() {
  return (
    <Layout>
      <AppHead />
      <NavBarV2 homeHref={links.site} myStuffHref={links.myStuff} navTargets={primaryNavTargets} signInHref={links.signIn} />
      <Hero createHref={links.create} />
      <LandingLazyLoad offset={100} once>
        <Suspense fallback={null}>
          <WhyBanner3 />
          <WhyBanner2 />
          <VideoBannerTop />
        </Suspense>
      </LandingLazyLoad>
      <LandingLazyLoad offset={300} once>
        <Suspense fallback={null}>
          <ExampleProjects />
        </Suspense>
      </LandingLazyLoad>
      <Footer createHref={links.create} forumHref={links.forum} highlightTargets={footerHighlightTargets} />
    </Layout>
  );
}
